import CSS from 'csstype';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

import { useCounter } from '../../hooks/useCounter';

const CounterComponent = (props) => {

    const plusIcon = <FontAwesomeIcon icon={faPlus} color='#ffffff' size='sm' />;
    const subsIcon = <FontAwesomeIcon icon={faMinus} color='#ffffff' size='sm' />;

    const { state, increment, decrement, setval } = useCounter(0);

    const handleInput = (e) => {
        setval(+e.target.value);
    }

    return (
        <div className='flex justify-center items-center'>
            <div className='mr-4 flex justify-center items-center' onClick={() => { decrement(1) }} style={buttonsStyle}>{subsIcon}</div>
            <input className="appearance-none block w-full text-gray-700 border border rounded py-3 px-4 h-12 w-12 leading-tight focus:outline-none focus:bg-white"
                value={state} id="grid-first-name" type="number" onChange={handleInput} />
            <div className='ml-4 flex justify-center items-center' onClick={() => { increment(1) }} style={buttonsStyle}>{plusIcon}</div>
        </div>
    )
}

const buttonsStyle: CSS.Properties = {
    borderRadius: '100%',
    height: '20px',
    width: '20px',
    color: '#fff',
    backgroundColor: '#67BAAF',
    fontWeight: '700',
    fontSize: '12px',
    cursor:'pointer'
}

CounterComponent.propTypes = {

}

export default CounterComponent
